import PropTypes from 'prop-types';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HOTSITES_LOGO_SRC } from '../../constants/hotsitesLogo';
import { cn } from '../../utils/cn';

const LOGO_ONLY_MS = 1800;

/**
 * Hotsites.nl footer badge with hover expand → logo-only animation.
 */
export function HotsiteBadge({ className }) {
  const { t } = useTranslation();
  const [isHover, setIsHover] = useState(false);
  const [isLogoOnly, setIsLogoOnly] = useState(false);
  const timerRef = useRef(null);

  const clearTimer = useCallback(() => {
    if (timerRef.current !== null) {
      window.clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  useEffect(() => () => clearTimer(), [clearTimer]);

  const handleMouseEnter = useCallback(() => {
    setIsHover(true);
    clearTimer();
    timerRef.current = window.setTimeout(() => {
      setIsLogoOnly(true);
      timerRef.current = null;
    }, LOGO_ONLY_MS);
  }, [clearTimer]);

  const handleMouseLeave = useCallback(() => {
    clearTimer();
    setIsHover(false);
    setIsLogoOnly(false);
  }, [clearTimer]);

  return (
    <p className={cn('hotsite-badge-wrap', className)}>
      <a
        href="https://www.hotsites.nl/"
        target="_blank"
        rel="noopener noreferrer"
        className={cn(
          'hotsite-badge',
          isHover && 'is-hover',
          isLogoOnly && 'is-logo-only',
        )}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <span className="hotsite-badge__text">{t('footer.hotsite')}</span>
        <img
          className="hotsite-badge__logo"
          alt={t('footer.hotsiteLogoAlt')}
          width={301}
          height={242}
          loading="eager"
          decoding="async"
          src={HOTSITES_LOGO_SRC}
        />
      </a>
    </p>
  );
}

HotsiteBadge.propTypes = {
  className: PropTypes.string,
};
